/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';

import { IEcommContentTemplate4ViewProps } from './ecomm-content-template-4';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommContentTemplate4ViewProps>}
 */
export class EcommContentTemplate4View extends React.PureComponent<IEcommContentTemplate4ViewProps> {
  public render(): JSX.Element | null {
    const { config, anchorID, TemplateContainerStyle } = this.props;

    const resultStyle = config.className && config.className !== '' ? `${TemplateContainerStyle.className}` + ` ` + `${config.className}` : TemplateContainerStyle.className;

    if (anchorID) {
      const style = `anchor ` + `${resultStyle}`;

      return <div id ={anchorID} className={style}>{this._renderInfo()}</div>;
    }

    return <div className={resultStyle}>{this._renderInfo()}</div>;
  }

  private _renderInfo(): JSX.Element | null {
    const { title, enablePrimaryColour, description, InfoContainerStyle, TitlePrimaryColour } = this.props;

    let result = (<p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{title}</p>);

    if (enablePrimaryColour) {
      result = (<p className={TitlePrimaryColour.className} id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{title}</p>);
    }

    return (
      <div className={InfoContainerStyle.className}>
        {result}
        <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>{description}</p>
      </div>
    );
  }
}

export default EcommContentTemplate4View;